import React from "react";

import { Row, Col } from "components/layout";

import ProcessProgress from "../ProcessProgress";
import UnloadingMethod from "../UnloadingMethod";
import TimeStat from "../TimeStat";
import { NextShiftMessage } from "../NextShift";

import conveyorImg from "../../assets/images/conveyor.svg";

const UnloadWithConveyorView = ({
  progress,
  progressColor,
  isBreakTime,
  currentTime,
  totalTime,
}) => {
  return (
    <Row align="middle" style={{ height: "100%" }}>
      <Col offset={1} span={9}>
        <ProcessProgress
          label="Progress"
          progress={progress}
          progressColor={progressColor}
          style={{
            width: "34vw",
            height: "34vw",
          }}
          textStyles={{
            fontSize: "8vw",
          }}
          labelStyles={{
            fontSize: "4vw",
          }}
        />
      </Col>
      {isBreakTime ? (
        <Col
          offset={1}
          span={12}
          style={{
            height: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Row>
            <NextShiftMessage>
              <span>Waiting for</span> <br />
              <span>work to</span>
              <br />
              <span>resume</span>
            </NextShiftMessage>
          </Row>
          <Row style={{ paddingTop: "8vh" }}>
            <TimeStat
              label="Total time"
              value={totalTime}
              styles={{
                value: {
                  color: "white",
                },
              }}
            />
          </Row>
        </Col>
      ) : (
        <Col offset={1} span={13}>
          <Row>
            <UnloadingMethod method="conveyor" imgSrc={conveyorImg} />
          </Row>
          <Row style={{ paddingTop: "8vh" }}>
            <TimeStat label="Your Time" value={currentTime} />
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default UnloadWithConveyorView;
